import { RowCrudStatus } from "../../common/types";
import { TenantStorageUsage } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";

export type TenantStorageUsageValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type TenantStorageUsageErrorsType = {};

export function TenantStorageUsageValuesInit(): TenantStorageUsageValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type TenantStorageUsageType =
  | TenantStorageUsage
  | TenantStorageUsageValuesType;

export function tenantStorageUsageDisplayId(
  source: Partial<TenantStorageUsage>,
  _langStore: LangStore
) {
  return `${graphqlToDateTime(source.timestamp)}`;
}

export function getTenantStorageUsageValues(
  source: TenantStorageUsageType,
  _langStore: LangStore,
  _duplicated: boolean = false
): TenantStorageUsageValuesType {
  const entityValues = TenantStorageUsageValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : tenantStorageUsageDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
